import { render, staticRenderFns } from "./CompleteMypageSection.vue?vue&type=template&id=a509473a"
import script from "./CompleteMypageSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompleteMypageSection.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports